import { useState } from 'react';
import styled from 'styled-components';

import { PAGES } from 'constants/pages';
import { useGetThermometersQuery } from 'data/__generated__';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { CreateThermometerPopup } from './Popups/CreateThermometerPopup';
import { ThermometersList } from './components/ThermometersList';

export const Thermometers = () => {
    const [isCreateThermometerPopupOpen, setIsCreateThermometerPopupOpen] = useState<boolean>(false);
    const { data: thermometersData } = useGetThermometersQuery();

    const sortedThermometers = [...(thermometersData?.getThermometers || [])].sort((a, b) => a.number - b.number);
    const nextThermometerNumber = (sortedThermometers[sortedThermometers.length - 1]?.number ?? 0) + 1;

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.thermometers} />
                </HeaderTitle>
                <ActionContainer>
                    <TotemPrimaryButton onClick={() => setIsCreateThermometerPopupOpen(true)}>
                        Ajouter un thermomètre
                    </TotemPrimaryButton>
                </ActionContainer>
            </Header>
            <Content>
                <ListContainer>
                    <ThermometersList />
                </ListContainer>
            </Content>
            <CreateThermometerPopup
                nextThermometerNumber={nextThermometerNumber}
                isOpen={isCreateThermometerPopupOpen}
                setIsOpen={setIsCreateThermometerPopupOpen}
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ActionContainer = styled.div`
    display: flex;
    & > :not(:first-child) {
        margin-left: 10px;
    }
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
